import Customer from './Customer'
import { Container, LabelRow, SubTitle } from './styles'

export default function TopCustomersList ({ customers = [] }) {
  return customers?.length > 0 && ( 
    <Container>
      <LabelRow>
        <SubTitle>Nome</SubTitle>
        <SubTitle>Total gasto</SubTitle>
      </LabelRow>
      {customers.map ((customer, index) => (
        <Customer key={index} data={customer}/>
      ))}
    </Container>
  )
}
